import { useTextes } from '@common/config';
import { Z_TEXT } from '@common/schemas';

const t = useTextes('Commun', 'PopupEtab');

export const CODE_POSTAL_REGEX = /^\d{5}$/;

export const Z_CODE_POSTAL = Z_TEXT(t['POPUP_ETAB_MSG7'])
  .regex(CODE_POSTAL_REGEX, { error: t['POPUP_ETAB_MSG8'] });

export const CODE_POSTAL_PLACEHOLDER = '56788';